/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const TrussEnvelopesIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 56 56"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'square', strokeMiterlimit: '2.8' }}
  >
    <g transform="matrix(1,0,0,1,-183,-1302)">
      <g id="Truss-Envelopes---Designs-" transform="matrix(0.542569,0,0,0.571048,170.006,406.545)">
        <g transform="matrix(0.82706,-3.36761e-16,-1.31659e-16,0.785812,-2019.76,1569.35)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(0.279111,2.20597e-32,-6.06642e-32,0.279494,-361.805,1347.21)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.105412,0,0,0.105412,-111.518,1541.41)">
          <path
            d="M1536.23,992.609L1840.56,688.285L2143.26,990.99L1536.23,992.609Z"
            style={{ fill: 'none', stroke: 'white', strokeWidth: '50.58px' }}
          />
        </g>
        <g>
          <g transform="matrix(-6.93889e-18,-0.0483857,-0.109805,0.000150681,136.086,1712.59)">
            <path
              d="M1664.82,751.754L1664.81,884.876L1775.07,834.167L1774.66,701.237L1664.82,751.754Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(-0.0361228,-0.0340987,-0.0791749,0.0759688,178.02,1620.81)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.0361228,-0.0340987,0.0207219,0.0198828,-2.60944,1649.84)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,-10.7045,-10.1728)">
          <g transform="matrix(-6.93889e-18,-0.0483857,-0.109805,0.000150681,140.884,1708.03)">
            <path
              d="M1664.82,751.754L1664.81,884.876L1775.07,834.167L1774.66,701.237L1664.82,751.754Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(-0.0361228,-0.0340987,-0.0656824,0.0630226,170.812,1627.73)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.0361228,-0.0340987,0.0207219,0.0198828,-2.60944,1649.84)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'TrussEnvelopesIcon',
);
